import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Container } from '@pella/sash-framework';

export const HoverEmbed = ({ configId = '3', email }) => {
	useEffect(() => {
		let necessary = true;
		let functional = true;
		let personalize = false;

		if (typeof OptanonActiveGroups !== 'undefined') {
			personalize = OptanonActiveGroups.includes('C0003');
		}

		const script = document.createElement('script');
		script.src = 'https://hover.to/designer/embed?version=1.0&key=277e2f79-7419-488b-99eb-ba0f5e26b086';
		script.async = true;
		script.dataset.cookieStrictlyNecessary = necessary;
		script.dataset.cookieFunctional = functional;
		script.dataset.cookiePersonalData = personalize;
		script.dataset.affOrgId = '277e2f79-7419-488b-99eb-ba0f5e26b086';
		script.dataset.embedConfigurationId = configId;
		if (email) script.dataset.userEmail = email;
		document.body.appendChild(script);

		return () => {
			document.body.removeChild(script);
		};
	}, [configId, email]);

	return (
		<Container>
			<div
				id='hover-website-embed'
				className='h-[600px] [@media(min-width:835px)]:h-[800px]'
				data-silktide='ignore'
			/>
		</Container>
	);
};

HoverEmbed.propTypes = {
	configId: PropTypes.string.isRequired,
	email: PropTypes.string,
};
